<div class="main-holder">
  <mat-toolbar>
    <button
      [matMenuTriggerFor]="menu"
      mat-icon-button aria-label="Menu button">
      <mat-icon>more_vert</mat-icon>
    </button>
    <span>Resource bookings</span>
  </mat-toolbar>
  <div class="content">
    <router-outlet/>
  </div>
  <div>
    &copy; ViaEuropa {{currentYear}}
  </div>
</div>

<mat-menu #menu="matMenu">
  <button mat-menu-item (click)="service.logout()">
    <mat-icon>logout</mat-icon>
    <span>Log out</span>
  </button>
  <mat-divider></mat-divider>
  <a mat-menu-item href="/openapi-schema.html" target="_blank">
    <mat-icon>new_window</mat-icon>
    <span>API Spec</span>
  </a>
</mat-menu>